import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Chargement...' }) => {
  return (
    <div className="min-h-screen bg-light-gray flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-2 border-forest-green"></div>
        <p className="mt-4 text-lg font-medium text-dark-black">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
